import { render } from "./Gymnastics.vue?vue&type=template&id=e79722da&scoped=true"
import script from "./Gymnastics.vue?vue&type=script&lang=js"
export * from "./Gymnastics.vue?vue&type=script&lang=js"

import "./Gymnastics.vue?vue&type=style&index=0&id=e79722da&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e79722da"]])

export default __exports__